<template>
	<section id="create-tipo-questao">
	<Notification ref="notif" :closed="true" corner="bottom-right" />
		<form @submit.prevent="saveTipoQuestao">
		<container textButton="voltar" :pathName="path" :pathIcone="true">
			<div class="errors">
				<div v-if="submitted && $v.form.descricao.$error" class="invalid-feedback">
					<p v-if="!$v.form.descricao.required">A descricao é obrigatória</p>
				</div>
			</div>
			<div class="form-controls">
				<div :class="[submitted && $v.form.descricao.$error && 'is-invalid', 'field descricao']">
						<input type="text" name="descricao" id="descricao" placeholder="Digite a descrição" v-model.lazy="form.descricao" autocomplete="off" />
				</div>
			</div>
		</container>
			<div class="submit-form">
				<button-submit class="large" type="submit" :disabled="loadingSubmit">
					<load-submit v-if="loadingSubmit"></load-submit>
					<span v-else>SALVAR</span>
				</button-submit>
			</div>
		</form>
	</section>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { tipoQuestao } from '@/services/tipoQuestao'
import LoadSubmit from '@/components/shared/LoadSubmit'
import Container from '@/components/shared/Container'
import ButtonSubmit from '@/components/shared/ButtonAction'
export default {
	name: 'createCuradoria',
	components: { Container, ButtonSubmit, LoadSubmit },
	data () {
		return {
			path: '',
			form: {
				descricao: ''
			},
			submitted: false,
			loadingSubmit: false
		}
	},
	validations () {
		return {
			form: {
				descricao: {
					required
				}
			}
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.path = from.path
		})
	},
	async created () {
		if (this.$route.params.id) {
			const { data: { descricao } } = await tipoQuestao.findById(this.$route.params.id)
			this.form.descricao = descricao
		}
	},
	methods: {
		async saveTipoQuestao () {
			this.submitted = true
			this.loadingSubmit = true
			this.$v.$touch()
			if (this.$v.form.descricao.$invalid) {
				this.loadingSubmit = false
				return false
			}

			this.sending = false
			if (this.$route.params.id) {
				try {
					await tipoQuestao.update(this.$route.params.id, this.form)
					// window.notificationEM.open('', 'Salvo com sucesso!', 'success')
					this.$router.push({ name: 'tiposQuestoesList', params: { alert: 'success', message: 'Alterado com sucesso!' } })
				} catch (err) {
					window.notificationEM.open('', 'Houve uma falha ao salvar, tente novamente mais tarde!', 'error')
				}
			} else {
				try {
					await tipoQuestao.createTipoQuestao(this.form)
					this.$router.push({ name: 'tiposQuestoesList', params: { alert: 'success', message: 'Cadastrado com sucesso!' } })
				} catch (err) {
					window.notificationEM.open('', 'Houve uma falha ao salvar, tente novamente mais tarde!', 'error')
				}
			}
			this.sending = true
		}
	}
}
</script>
<style lang="scss" scoped>
#create-tipo-questao{
	.form-controls {
		display: grid;
		margin-top: 46px;
		.field {
			background-color: #f3f7fc;
			border-radius: 5px;
			color: #4f5c6b;
			height: 50px;
			display: flex;
			align-items: center;
			padding: 8px 11px;

			input[type=text] {
				border: none;
				outline: none;
				background: transparent;
				width: 100%;
				height: 100%;
				font-size: 1em;
				padding-left: 8px;
				background-color: rbga(255, 255, 255, 0.2);
			}
		}
		.submit {
			display: flex;
			justify-content: center;
			margin-top: 30px;
		}
	}
}
</style>
